import {
  getFailedState,
  getInitialState,
  getRequestingState,
  getSuccessState,
} from '@utils/store';
import { AuthActions } from '../actions/auth-actions';
import { SIGN_IN, SIGN_OUT } from '../actions/types';
import { AuthState } from './types/auth-state';

const initialState = {
  request: false,
};

const AuthReducer = (state = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case SIGN_IN.SIGN_IN_REQUEST:
      return {
        ...getRequestingState(),
      };

    case SIGN_IN.SIGN_IN_SUCCESS: {
      return {
        ...getSuccessState(),
      };
    }

    case SIGN_IN.SIGN_IN_FAILED:
      return {
        ...getFailedState(),
      };

    case SIGN_OUT.SIGN_OUT_REQUEST:
      return {
        ...getInitialState(),
      };

    default:
      return state;
  }
};

export default AuthReducer;
